export const techParametersMap = {
  turbineType: '机组型号',
  vendor: '制造厂商',
  ratedPower: '额定功率',
  bladeDiameter: '叶轮直径',
  bladeLength: '叶片长度',
  sweptArea: '扫风面积',
  hubHeight: '轮毂高度',
  securityLevel: '安全等级',
  wspdIn: '切入风速',
  ratedSpeed: '额定风速',
  wspdOut: '切出风速',
  maxSpeed: '极端（生存）风速',
  runningTempRange: '机组运行温度范围',
  existTempRange: '机组生存温度范围',
  life: '设计使用寿命'
};

export const techParametersUnit = {
  turbineType: '',
  vendor: '',
  ratedPower: 'kW',
  bladeDiameter: 'm',
  bladeLength: 'm',
  sweptArea: '㎡',
  hubHeight: 'm',
  securityLevel: '',
  wspdIn: 'm/s',
  ratedSpeed: 'm/s',
  wspdOut: 'm/s',
  maxSpeed: 'm/s',
  runningTempRange: '℃',
  existTempRange: '℃',
  life: 'Year'
};
